/*
 * CODE GENERATED AUTOMATICALLY WITH GraphQL Codegen
 * THIS FILE SHOULD NOT BE EDITED MANUALLY.
 */
import {
  BaseQueryModel,
  IQueryModelOpts,
  useQuery,
  useGqlClient,
} from '@r-client/shared/data/client';
import {
  IGetBrazeAuthJwtQuery,
  IGetBrazeAuthJwtQueryVariables,
  GetBrazeAuthJwtDocument,
} from './types';

export type IGetBrazeAuthJwtQueryOpts =
  IQueryModelOpts<IGetBrazeAuthJwtQueryVariables>;

export class GetBrazeAuthJwtQuery extends BaseQueryModel<
  IGetBrazeAuthJwtQuery,
  IGetBrazeAuthJwtQueryVariables
> {
  // This is fine. Here we explicitly change interface for query
  // eslint-disable-next-line @typescript-eslint/no-useless-constructor
  constructor(opts: IGetBrazeAuthJwtQueryOpts) {
    super(opts);
  }

  get query() {
    return GetBrazeAuthJwtDocument;
  }
}
export function useGetBrazeAuthJwtQuery(
  opts?: Omit<IGetBrazeAuthJwtQueryOpts, 'client'>
) {
  const client = useGqlClient();
  return useQuery(
    () => new GetBrazeAuthJwtQuery({ ...opts, client }),
    opts?.variables
  );
}
